import { types } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import { AET_STORE_EVENTS, TOC_MAPPING_STRATEGY } from '../common/Constants';

const TocChapter = types.model('TocChapter', {
  num: types.number,
  tocTitle: types.maybeNull(types.string),
  tocId: types.maybeNull(types.string),
  id: types.maybeNull(types.string)
});

const TocSection = types.model('TocSection', {
  num: types.string,
  tocId: types.maybeNull(types.string)
});

const TocMapping = types.model('TocMapping', {
  chapters: types.array(TocChapter),
  sections: types.optional(types.array(TocSection), [])
})
  .actions(self => ({
    requestTocMapping({
      bookId,
      productModel,
      chapters,
      sections = [],
      strategy,
      graphConfig
    }) {
      switch (strategy) {
        case TOC_MAPPING_STRATEGY.BERLIN_GRAPH:
          Framework.getEventManager().publish(AET_STORE_EVENTS.BERLIN_TOC_MAPPING_REQUESTED, {
            bookId,
            productModel,
            chapters,
            sections,
            graphConfig
          });
          break;
        case TOC_MAPPING_STRATEGY.PRISM_LLM:
          Framework.getEventManager().publish(AET_STORE_EVENTS.TOC_MAPPING_REQUESTED, {
            bookId,
            productModel,
            chapters,
            sections,
            isLLM: true
          });
          break;
        default:
          Framework.getEventManager().publish(AET_STORE_EVENTS.TOC_MAPPING_REQUESTED, {
            bookId,
            productModel,
            chapters,
            sections,
            isLLM: false
          });
      }
    },
    setTocMapping(data) {
      if (data && data.chapters) {
        self.chapters.replace(data.chapters);
      }
      if (data && data.sections) {
        self.sections.replace(data.sections);
      }
    }
  }));

export { TocMapping, TocChapter, TocSection };
export default TocMapping;
